import { IDashboardMetadata, IRowCountCtx } from '../dashboard-metadata.service';
import { SAT_TICKET_COLUMNS, TICKET_SORT, uniqueCountIndicator } from './shared-dashboard.config';
import { IReportData } from '../../../../shared/report/report-data.service';
import { OemDashboardFiltersComponent } from '../filters/oem/oem-dashboard-filters.component';
import { DateType } from '../../../../shared/services/date.util';

export const INTEL_KPI_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'INTEL KPI',
  filterComponent: {
    name: OemDashboardFiltersComponent,
    inputs: {
      showIntelFields: true
    }
  },
  mapping: {
    Decounm: 'country.id',
    Desprnm: 'customer.id',
    Deconti: 'geography.name',
    Pacomnm: 'bp.companyCountryId',
    Vecomnm: 'oem.id',
    Vnlname: 'vnam.fullName',
    Arm_name: 'arm.id',
    Odlname: 'pss.id',
    Degboen: 'gbdmOEM.id'
  },
  reports: [
    {
      id: 166,
      key: 'OEM_OPEN_ITEMS',
      columns: [
        {
          name: 'Vecomnm', //Vendor
          groupingSequence: 1
        },
        {
          name: 'Decounm', //Country
          aggregate: 'cnt'
        },
        {
          name: 'Degboen', //GBDM OEM
          aggregate: 'cnt'
        },
        {
          name: 'Derecid2', //ACSL #
          aggregate: 'cnt'
        }
      ],
      sort: [
        {
          name: 'Derecid2',
          direction: 'desc'
        }
      ],
      indicatorFn: (reportData:IReportData, ctx:IRowCountCtx) => uniqueCountIndicator(reportData, ctx, 'Vecomnm')
    },
    {
      id: 166,
      key: 'VNAM_OPEN_ITEMS',
      fixedFilters: {
        Vnam_id: 'is not null'
      },
      comments: ' ',
      columns: [
        {
          name: 'Vnlname', //VNAM
          groupingSequence: 1
        },
        {
          name: 'Delvenm_sh', //Local Vendor
          aggregate: 'cnt'
        },
        {
          name: 'Vecomnm', //Vendor
          aggregate: 'cnt'
        },
        {
          name: 'Decounm', //Country
          aggregate: 'cnt'
        },
        {
          name: 'Degboen', //GBDM OEM
          aggregate: 'cnt'
        },
        {
          name: 'Derecid2', //ACSL #
          aggregate: 'cnt'
        }
      ],
      sort: [
        {
          name: 'Derecid2',
          direction: 'desc'
        }
      ],
      indicatorFn: (reportData:IReportData, ctx:IRowCountCtx) => uniqueCountIndicator(reportData, ctx, 'Vnlname')
    },
    {
      id: 166,
      key: 'VREP_OPEN_ITEMS',
      fixedFilters: {
        Vnam_id: 'is null',
        Local_vendor_id: 'is not null'
      },
      comments: ' ',
      columns: [
        {
          name: 'Delvenm_sh', //VREP
          groupingSequence: 1
        },
        {
          name: 'Vecomnm', //Vendor
          aggregate: 'cnt'
        },
        {
          name: 'Decounm', //Country
          aggregate: 'cnt'
        },
        {
          name: 'Degboen', //GBDM OEM
          aggregate: 'cnt'
        },
        {
          name: 'Derecid2', //ACSL #
          aggregate: 'cnt'
        }
      ],
      sort: [
        {
          name: 'Derecid2',
          direction: 'desc'
        }
      ],
      indicatorFn: (reportData:IReportData, ctx:IRowCountCtx) => uniqueCountIndicator(reportData, ctx, 'Delvenm_sh')
    },
    {
      id: 166,
      key: 'OEM_OPEN_ITEMS_NO_CONTACT',
      fixedFilters: {
        Vnam_id: 'is null',
        Local_vendor_id: 'is null'
      },
      comments: ' ',
      columns: [
        {
          name: 'Vecomnm', //Vendor
          groupingSequence: 1
        },
        {
          name: 'Decounm', //Country
          aggregate: 'cnt'
        },
        {
          name: 'Degboen', //GBDM OEM
          aggregate: 'cnt'
        },
        {
          name: 'Pacomnm', //ACSL #
          aggregate: 'cnt'
        },
        {
          name: 'Derecid2', //ACSL #
          aggregate: 'cnt'
        }
      ],
      sort: [
        {
          name: 'Derecid2',
          direction: 'desc'
        }
      ],
      indicatorFn: (reportData:IReportData, ctx:IRowCountCtx) => uniqueCountIndicator(reportData, ctx, 'Vecomnm')
    },
    {
      id: 219,
      key: 'DUE_INVOICES',
      mapping: {
        Gbdm_name: 'gbdmOEM.id'
      },
      fixedFilters: {
        Decovst_ds: 'Operational issues'
      },
      restricted: true
    },
    {
      id: 219,
      key: 'PROBLEMATIC_INVOICES',
      mapping: {
        Gbdm_name: 'gbdmOEM.id'
      },
      fixedFilters: {
        Problematic: 1
      },
      restricted: true
    },
    {
      browselistCode: 'TICKET',
      key: 'BP_SAT_TICKETS',
      mapping: {
        Shcounm: 'country.id',
        Deccoid: 'bp.companyCountryId',
        Shgbdmn: 'gbdmOEM.id'
      },
      fixedFilters: {
        Demntty: '@SAT@'
      },
      columns: SAT_TICKET_COLUMNS,
      sort: TICKET_SORT
    },
    {
      id: 74,
      key: 'BP_CHECKED_MIN_1Y',
      mapping: {
        Deccoid: 'bp.companyCountryId',
        Decodnm: 'pss.id',
        Degbdmn: 'gbdmOEM.id'
      },
      fixedFilters: {
        Max_oem_ranking: '1',
        Check_date_TO: DateType.ONE_YEAR_AGO
      },
      columns: [
        {
          name: 'Decomnm',
          label: 'BP'
        },
        'Decounm',
        'Decodnm',
        'Degbdmn',
        'Check_date',
        'Check_author',
        'Check_comments'
      ]
    },
    {
      id: 74,
      key: 'BP_CHECKED_MAX_1Y',
      mapping: {
        Deccoid: 'bp.companyCountryId',
        Decodnm: 'pss.id',
        Degbdmn: 'gbdmOEM.id'
      },
      fixedFilters: {
        Max_oem_ranking: '1',
        Check_date_FROM: DateType.ONE_YEAR_AGO
      },
      columns: [
        {
          name: 'Decomnm',
          label: 'BP'
        },
        'Decounm',
        'Decodnm',
        'Degbdmn',
        'Check_date',
        'Check_author',
        'Check_comments'
      ]
    }
  ]
};